import { BookOpenCheck, MessageCircleQuestion } from "lucide-react";
import QuestionOptionsStatic from "./QuestionOptionsStatic";
import { useEffect } from "react";
import QuestionRichContent from "./QuestionRichContent";

const MockTestQuestionLoading =({currentQuestionObject,mockTestCard1Object,SetQuestionAnswered,showQuestionOptions,index})=>{
  // useEffect(()=>{console.log(currentQuestionObject)},[])
    return(<>
    <div className={"questionDivideColumn"} style={{margin:"0px" ,background:"#ffffff",border:"0px solid #ffffff",height:"69vh",}}>
    <div>   
      
     
       <div className="maxHeightLG"style={{marginTop:"20px",overflow:"auto",padding:"10px",fontSize:"18px",borderTopLeftRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomRight?.resolution}`,
}}> 
        
         <div className="text-linetw" style={{margin:"10px",width:"90%",height:"150px",alignItems:"left"}}>
           </div> 
     
 </div>
 </div>

<div className="maxHeightLGOptions ">   
  <div className="text-linetw" style={{margin:"10px",width:"90%",height:"50px",alignItems:"left"}}>
           </div>
   <div className="text-linetw" style={{margin:"10px",width:"90%",height:"50px",alignItems:"left"}}>
           </div>
   <div className="text-linetw" style={{margin:"10px",width:"90%",height:"50px",alignItems:"left"}}>
           </div>
   <div className="text-linetw" style={{margin:"10px",width:"90%",height:"50px",alignItems:"left"}}>
           </div>
       </div></div>
      <style>{`
      .maxHeightLG{max-height:55vh;overflow-y:auto}
     .maxHeightLGOptions{max-height:57vh;overflow-y:auto;margin-top:50px;}
      
       /* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .maxHeightLG{max-height:80vh;overflow-y:auto}
     .maxHeightLGOptions{max-height:80vh;overflow-y:auto}
    
      }
  /* sm */
@media (min-width: 768px) and (max-width: 991px) {
 .maxHeightLGOptions,.maxHeightLG{max-height:100%;}
 }
 
/* xs */
@media (max-width: 767px) {
 .maxHeightLGOptions,.maxHeightLG{max-height:100%;}
 }
 
      `}</style>
    </>)
}
export default MockTestQuestionLoading;